export default {
  lastSearchString: "",
  lastScanString: "",
  loadingModifyId: null,
};
